<template>
  <div class="package-extra-editor">
    <div class="title-row">
      <el-input v-model="title" type="text"></el-input>
      <sc-button
        v-if="!disabled"
        variant="primary"
        class="btn-add-group"
        @click="handleClickAddGroup"
      >เพิ่มกลุ่ม</sc-button>
    </div>

    <div v-for="(group, index) in sections" :key="index" class="phone-group">
      <div class="group-title-row">
        <div class="group-title-input">
          <label class="label">ชื่อกลุ่ม</label>
          <el-input
            type="text"
            :value="group.title"
            @input="handleInputGroup(index, $event)"
          ></el-input>
        </div>
        <sc-button
          v-if="!disabled"
          variant="danger"
          class="btn-delete-group"
          @click="handleClickRemoveGroup(index)"
        >ลบกลุ่ม</sc-button>
      </div>

      <div
        v-for="(input, inputIndex) in group.inputs"
        :key="`${index}-${inputIndex}`"
        class="row mb-4 input"
      >
        <div class="col-3">
          <label class="label">หัวข้อ</label>
          <el-input
            :value="input.title"
            type="text"
            @input="handleInputInput(index, inputIndex, 'title', $event)"
          ></el-input>
        </div>
        <div class="col-2">
          <label class="label">ประเภท</label>
          <el-select
            :value="input.type"
            :disabled="disabled"
            placeholder="เลือก"
            @input="handleInputInput(index, inputIndex, 'type', $event)"
          >
            <el-option
              v-for="extra in extraTypeOptions"
              :key="extra.value"
              :value="extra.value"
              :label="extra.label"
            >{{ extra.label }}</el-option>
          </el-select>
        </div>
        <div v-show="!isCitizenCardImage(input.type)" class="col-3">
          <label class="label">เหมาะสำหรับ</label>
          <el-select
            :value="input.prefillKey"
            :disabled="disabled"
            placeholder="ไม่ Pref"
            clearable
            @input="handleInputInput(index, inputIndex, 'prefillKey', $event)"
          >
            <el-option
              v-for="extra in extraPrefillOptions"
              :key="extra.value"
              :value="extra.value"
              :label="extra.label"
            >{{ extra.label }}</el-option>
          </el-select>
        </div>
        <div v-show="isCitizenCardImage(input.type)" class="col-3">
          <sc-button
            v-if="!disabled"
            class="watermark-button"
            @click="handleClickChooseWatermarkImage(index, inputIndex, input.watermarkUrl, input.watermarkFile)"
          >{{ watermarkButtonName(input.watermarkUrl) }}</sc-button>
        </div>
        <div class="col-auto required-col">
          <el-checkbox
            :disabled="disabled"
            :value="input.isRequired"
            class="required-checkbox"
            @input="handleInputInput(index, inputIndex, 'isRequired', $event)"
          >จำเป็น</el-checkbox>
        </div>
        <div class="col-auto">
          <sc-button
            v-if="!disabled"
            variant="danger"
            class="btn-delete"
            @click="handleClickRemoveInput(index, inputIndex)"
          >ลบหัวข้อ</sc-button>
        </div>
      </div>

      <div v-if="!disabled" class="row">
        <div class="col-12">
          <sc-button class="w-100 btn-add-input" @click="handleClickAddInput(index)">เพิ่มหัวข้อ</sc-button>
        </div>
      </div>
    </div>

    <image-picker-modal
      v-bind="chooseWatermarkImageDialog"
      @cancel="handleCancelChooseWatermarkImage"
      @confirm="handleConfirmChooseWatermarkImage('watermarkFile', $event)"
    ></image-picker-modal>
  </div>
</template>

<script>
import ScButton from "@/lib/components/ScButton";
import { Input, Select, Option, Checkbox } from "element-ui";
import ImagePickerModal from "@/lib/components/ImagePickerModal";
import { isNil } from "ramda";

export default {
  components: {
    ScButton,
    ElInput: Input,
    ImagePickerModal,
    "el-select": Select,
    "el-option": Option,
    "el-checkbox": Checkbox
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const extraTypeOptions = [
      { value: "TEXT", label: "ข้อความ" },
      { value: "LONG_TEXT", label: "ข้อความยาว" },
      { value: "CITIZEN_CARD_IMAGE", label: "รูปบัตรประชาชน" }
    ];

    const extraPrefillOptions = [
      { value: "NAME", label: "ชื่อ" },
      { value: "MOBILE_NUMBER", label: "เบอร์โทรศัพท์" }
    ];

    return {
      extraPrefillOptions,
      extraTypeOptions,
      isShowWatermarkImageDialog: false,
      watermarkImage: {
        file: null,
        url: null,
        groupIndex: null,
        inputIndex: null
      }
    };
  },
  computed: {
    title: {
      get() {
        return this.value.title;
      },
      set(title) {
        this.$emit("input", { ...this.value, title });
      }
    },
    sections() {
      return this.value.sections;
    },
    chooseWatermarkImageDialog() {
      return {
        isShow: this.isShowWatermarkImageDialog,
        isLoading: false,
        canEdit: true,
        title: "เลือกรูปภาพลายน้ำบัตรประชาชน",
        width: 800,
        height: 500,
        // TODO: remove ENV check when ready to production
        accept: process.env.DEPLOY_ENV !== "production" ? "image/png" : null,
        message: process.env.DEPLOY_ENV !== "production" ? "เป็นไฟล์สกุล png เท่านั้น" : null,
        recommendWidth: 800,
        recommendHeight: 500,
        thumbnailFile: this.watermarkImage.file,
        thumbnailUrl: this.watermarkImage.url
      };
    }
  },
  methods: {
    watermarkButtonName(watermarkUrl) {
      return isNil(watermarkUrl) ? "เพิ่มลายน้ำ" : "แก้ไขลายน้ำ"
    },
    handleClickRemoveGroup(index) {
      this.$emit("input", {
        ...this.value,
        sections: this.value.sections.filter((_, i) => index !== i)
      });
    },
    handleClickRemoveInput(groupIndex, inputIndex) {
      this.$emit("input", {
        ...this.value,
        sections: this.value.sections.map((group, i) =>
          i === groupIndex
            ? {
                ...group,
                inputs: group.inputs.filter((_, ci) => ci !== inputIndex)
              }
            : group
        )
      });
    },
    handleClickAddInput(groupIndex) {
      this.$emit("input", {
        ...this.value,
        sections: this.value.sections.map((group, index) =>
          groupIndex === index
            ? {
                ...group,
                inputs: [
                  ...group.inputs,
                  {
                    title: null,
                    type: "",
                    prefillKey: null,
                    isRequired: false,
                    watermarkUrl: null,
                    watermarkFile: null
                  }
                ]
              }
            : group
        )
      });
    },
    handleClickChooseWatermarkImage(groupIndex, inputIndex, watermarkUrl, watermarkFile) {
      this.watermarkImage.url = watermarkUrl || null
      this.watermarkImage.file = watermarkFile || null;
      this.watermarkImage.groupIndex = groupIndex;
      this.watermarkImage.inputIndex = inputIndex;
      this.isShowWatermarkImageDialog = true;
    },
    handleConfirmChooseWatermarkImage(name, event) {
      this.$emit("input", {
        ...this.value,
        sections: this.value.sections.map((group, index) =>
          this.watermarkImage.groupIndex === index
            ? {
                ...group,
                inputs: group.inputs.map((input, cIndex) =>
                  cIndex === this.watermarkImage.inputIndex ? { ...input, [name]: event } : input
                )
              }
            : group
        )
      });

      this.isShowWatermarkImageDialog = false;
    },
    handleCancelChooseWatermarkImage() {
      this.isShowWatermarkImageDialog = false;
    },
    handleClickAddGroup() {
      this.$emit("input", {
        ...this.value,
        sections: [...this.value.sections, { title: "", inputs: [] }]
      });
    },
    handleInputGroup(index, event) {
      this.$emit("input", {
        ...this.value,
        sections: this.value.sections.map((group, i) =>
          i === index ? { ...group, title: event } : group
        )
      });
    },
    handleInputInput(groupIndex, inputIndex, name, event) {
      this.$emit("input", {
        ...this.value,
        sections: this.value.sections.map((group, index) =>
          groupIndex === index
            ? {
                ...group,
                inputs: group.inputs.map((input, cIndex) =>
                  cIndex === inputIndex ? { ...input, [name]: event } : input
                )
              }
            : group
        )
      });
    },
    isCitizenCardImage(type) {
      return type === "CITIZEN_CARD_IMAGE";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.title-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 24px;

  .el-input {
    flex: 1;
  }
}

.btn-add-group {
  flex: none;
  white-space: nowrap;
}

.phone-group {
  background: #f5f6f8;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.group-title-row {
  display: flex;
  align-items: flex-end;
  gap: 16px;
  margin-bottom: 20px;
}

.group-title-input {
  flex: 1;
}

.btn-delete-group {
  flex: none;
  white-space: nowrap;
}

.row.input {
  align-items: flex-end;
}

.required-col {
  display: flex;
  align-items: center;
}

.input .btn-delete {
  margin-bottom: 0;
}

.input .watermark-button {
  display: block;
  width: 100%;
}

.btn-add-input {
  background: $white;
  color: $dark;
}

.required-checkbox {
  margin: 0;
}
</style>

